// extracted by mini-css-extract-plugin
module.exports = {"reviewFormSuccess":"JT","successIcon":"KT","desktopMessage":"LT","mobileMessage":"MT"};